import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustTicker from "@/components/site/TrustTicker";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import RecentProjects from "@/components/site/RecentProjects";
import CompleteDelivery from "@/components/site/CompleteDelivery";
import Refurbishment from "@/components/site/Refurbishment";
import ScopeBanner from "@/components/site/ScopeBanner";
import Process from "@/components/site/Process";
import AreasCovered from "@/components/site/AreasCovered";
import QuoteForm from "@/components/site/QuoteForm";
import ContactSection from "@/components/site/ContactSection";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";

export default function DemolitionPage() {
  return (
    <main data-testid="demolition-page" className="bg-[#FAF8F4] text-[#2B2420]">
      <Navbar />
      <Hero />
      <TrustTicker />
      <Services />
      <RecentProjects />
      <WhyUs />
      <CompleteDelivery />
      <Refurbishment />
      <ScopeBanner />
      <Process />
      <AreasCovered />
      <QuoteForm />
      <ContactSection />
      <Faq />
      <Footer />
      <MobileStickyCTA />
    </main>
  );
}
